import { useState, useEffect } from 'react';
import type { Theme } from '@/types';

const STORAGE_KEY = 'ps-theme';
const HTML_ATTR   = 'data-theme';

function getInitialTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return 'dark';
}

export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute(HTML_ATTR, theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  function toggle(): void {
    setTheme(current => current === 'dark' ? 'light' : 'dark');
  }

  return [theme, toggle];
}
